import React from "react"
import { TM } from "./trademark"

export const LearnMoreTagline = (
  <>
    Learn More About the IronCAP
    <TM /> Cryptographic System
  </>
)
